import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { catchError, switchMap, filter, take, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NgZone } from '@angular/core';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<string | null> =
    new BehaviorSubject<string | null>(null);

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private ngZone: NgZone
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser && currentUser.accessToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.accessToken}`,
        },
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          console.error('Erreur 401 trouver et resolution lancée...');
          if (this.isAccessTokenExpired(currentUser)) {
            console.error('dans la condition...');
            if (!this.isRefreshing) {
              console.log('pas en refresh');
              this.isRefreshing = true;
              this.refreshTokenSubject.next(null);
              return this.authenticationService.refreshToken().pipe(
                switchMap((adminData: any) => {
                  console.log('refresh reussi..', adminData);
                  this.authenticationService.setCurrentUser(adminData)
                  localStorage.setItem(
                    'currentUser',
                    JSON.stringify(adminData)
                  );

                  request = request.clone({
                    setHeaders: {
                      Authorization: `Bearer ${adminData.accessToken}`,
                    },
                  });
                  console.log('clonage de requete effectué avec succes...');
                  this.refreshTokenSubject.next(adminData.accessToken);
                  this.isRefreshing = false;
                  this.authenticationService.isAuthenticated.next(true);
                  return next.handle(request).pipe(
                    tap({
                      next: (data) => {
                        console.log(
                          'Reussite et transfert de données du refresh',
                          data
                        );
                      },
                      error: (err) => {
                        console.log(
                          'Erreur lors du transfert de données du refresh token',
                          err
                        );
                      },
                    })
                  );
                }),
                catchError((refreshError) => {
                  this.ngZone.run(() => {
                    this.authenticationService.logout();
                    this.router.navigate(['/auth/']);
                  });
                  this.isRefreshing = false;
                  return throwError(() => refreshError);
                })
              );
            } else {
              console.log('deja en refresh...');
              return this.refreshTokenSubject.pipe(
                filter((token) => token !== null),
                take(1),
                switchMap((token) => {
                  request = request.clone({
                    setHeaders: {
                      Authorization: `Bearer ${token}`,
                    },
                  });
                  return next.handle(request);
                })
              );
            }
          }
        }
        return throwError(() => error);
      })
    );
  }

  private decode(token: string): any {
    return JSON.parse(atob(token.split('.')[1]));
  }

  private isAccessTokenExpired(currentUser: any): boolean {
    const token = currentUser.accessToken;
    const decodedToken = this.decode(token);
    const expirationTime = decodedToken.exp * 1000;
    const currentTime = Date.now();
    const expirationThreshold = expirationTime - 20 * 60 * 1000;

    console.log(
      'Jwt decoder : ',
      decodedToken,
      currentTime >= expirationThreshold
    );

    return currentTime >= expirationThreshold;
  }
}
